import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SettingsNav.css';

const ITEMS = [
  { label: 'My Info', to: '/settings/info' },
  { label: "KPI's", to: '/settings/kpis' },
];

/**
 * SettingsNav — small in-page sub-nav shared by the /settings/* pages,
 * mirroring the "Settings" dropdown in the navbar so it's just as easy
 * to jump between My Info and KPI's from within either page.
 */
const SettingsNav = () => {
  const location = useLocation();
  return (
    <nav className="settings-nav">
      {ITEMS.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className={`settings-nav__link${location.pathname === item.to ? ' settings-nav__link--active' : ''}`}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default SettingsNav;
